import {getTmdbImage} from "../../../utils/consts";
import './tmdbResultCard.css';
import {useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import {getViewMessage} from "../../../utils/utils";
import {useMemo} from "react";
import useSquadflixNavigate from "../squadflixHome/useSquadflixNavigate";

function TmdbResultCard({props, linked = true, from, onClick, customBottomInfo}) {
    const navigate = useNavigate();
    const squadflixNav = useSquadflixNavigate({});
    const intl = useIntl();

    const isMovie = props.hasOwnProperty('title');

    const date = props.release_date ?? props.first_air_date;

    const playStatus = useMemo(() => {
        if (props.can_play) {
            return "playable"
        }
        if (props.downloading) {
            return "downloading"
        }
        return "not-playable"
    }, [props.can_play, props.downloading]);

    return (

        <div className="card mb-3 tmdb-result-card" style={{maxHeight: "100px", overflow: "hidden"}}
             onClick={e => {
                 if (linked && !onClick) {
                     if (isMovie) {
                         squadflixNav.navigateToMovie(props);
                     } else {
                         squadflixNav.navigateToSerie(props);
                     }
                 }
                 if (onClick) {
                     onClick(e);
                 }
             }}>
            <div className="col-12 d-flex flex-row" style={{
                height: "100px",
            }}>
                <img style={{height: "100%", aspectRatio: "3/4", objectFit: "cover"}}
                     src={getTmdbImage(props['poster_path'], "w200")}
                     alt={props.title}
                     className="img-fluid rounded-start"/>
                <div className="card-body ps-2 pe-0">
                    <h5 className="card-title pe-2" style={{
                        height: "50px",
                        verticalAlign: "middle",
                    }}>{props.title ?? props.name}</h5>
                    <div className="card-text d-flex justify-content-between pe-2">
                        {!customBottomInfo && <>
                            <small className="text-body-secondary">
                                {date && new Date(date).toLocaleDateString()}
                            </small>
                            <div className="d-flex flex-row align-items-center gap-1">
                                {!!props.has_notes &&
                                    <i title={intl.formatMessage({id: "tmdb-result-card.info-icons.has-notes"})}
                                       className="fa-regular fa-note-sticky text-muted"></i>}
                                {!props.view && !!props.start_view &&
                                    <i className="fa-solid fa-check text-muted"></i>}
                                {!props.view && !props.start_view && !!props.view_later &&
                                    <i title={intl.formatMessage({id: "tmdb-view-later.button.title"})}
                                       className="fa-solid fa-clock-rotate-left fa-flip-horizontal text-muted"></i>}
                                {!!props.view &&
                                    <i title={getViewMessage(intl, props.view_date)}
                                       className="fa-solid fa-check-double text-muted"></i>}
                                {playStatus === "not-playable" &&
                                    <i title={intl.formatMessage({id: "tmdb-result-card.info-icons.cannot-play"})}
                                       className="fa-regular fa-circle text-muted"></i>}
                                {playStatus === "playable" &&
                                    <i title={intl.formatMessage({id: "tmdb-result-card.info-icons.can-play"})}
                                       className="fa-regular fa-circle-play text-muted"></i>}
                                {playStatus === "downloading" &&
                                    <i title={intl.formatMessage({id: "tmdb-result-card.info-icons.downloading"})}
                                       className="fa-regular fa-circle text-muted fa-beat-fade"></i>}
                            </div>
                        </>}
                        {customBottomInfo}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TmdbResultCard;
